module.exports = __webpack_public_path__ + "static/media/logo_acredicoop.c1a3209f.svg";